import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './HomePage.css';

const HomePage = () => {
  const navigate = useNavigate();
  const [currentTime, setCurrentTime] = useState(new Date());

  // Update time every second
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  const formatDate = (date) => {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}.${month}.${year}`;
  };

  const formatTime = (date) => {
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    return `${hours}:${minutes}:${seconds}`;
  };

  const navigationLinks = [
    { id: 'about', title: 'About', path: '/about', icon: '◈', desc: 'Skills, experience, and education' },
    { id: 'projects', title: 'Projects', path: '/projects', icon: '◆', desc: 'Code experiments and research papers' },
    { id: 'blogs', title: 'Blogs', path: '/blogs', icon: '▣', desc: 'Writing on data science and ML' },
    { id: 'diary', title: 'Digital Diary', path: '/diary', icon: '▤', desc: 'Thoughts and daily reflections' },
    { id: 'socials', title: 'Socials', path: '/socials', icon: '◎', desc: 'Connect with me online' }
  ];

  const handleLinkClick = (path) => {
    navigate(path);
  };

  const handleKeyDown = (e, path) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      navigate(path);
    }
  };

  return (
    <div className="homepage">
      {/* Decorative corner borders */}
      <div className="corner-decor top-left">┌</div>
      <div className="corner-decor top-right">┐</div>
      <div className="corner-decor bottom-left">└</div>
      <div className="corner-decor bottom-right">┘</div>

      <div className="homepage-content">
        {/* Game Title Card */}
        <div className="hero-panel">
          <div className="panel-header">
            <span className="panel-title-decor">═══════════════</span>
            <span className="panel-title-text">PLAYER INFO</span>
            <span className="panel-title-decor">═══════════════</span>
          </div>

          <div className="hero-body">
            <div className="avatar-container">
              <div className="pixel-avatar">
                <img 
                  src="/avatar.png" 
                  alt="Vainavi Nair" 
                  className="avatar-image"
                />
              </div>
              <div className="status-indicator">
                <span className="status-dot">●</span>
                <span className="status-text">ONLINE</span>
              </div>
            </div>

            <div className="hero-info">
              <h1 className="hero-name">VAINAVI_NAIR</h1>
              <div className="hero-role">
                <span className="role-bracket">[</span>
                <span className="role-text">DATA_SCIENTIST</span>
                <span className="role-bracket">]</span>
              </div>
              
              {/* XP Bar */}
              <div className="xp-container">
                <div className="xp-label">
                  <span>EXP</span>
                  <span>LVL 24</span>
                </div>
                <div className="xp-bar-wrapper">
                  <div className="xp-bar-bg">
                    <div className="xp-bar-fill" style={{ width: '75%' }}></div>
                  </div>
                </div>
              </div>

              <p className="hero-bio">
                &gt; A data science professional with a background in Computer Science and an MSc in Data Science.
                Experienced in machine learning, AI, and data engineering, with a strong focus on real-world applications.
              </p>
            </div>
          </div>
        </div>

        {/* Navigation Menu - Game Style */}
        <nav className="nav-panel">
          <div className="panel-header">
            <span className="panel-title-decor">══════</span>
            <span className="panel-title-text">MAIN MENU</span>
            <span className="panel-title-decor">══════</span>
          </div>

          <div className="nav-menu">
            {navigationLinks.map((link, index) => (
              <button
                key={link.id}
                className="nav-menu-item"
                onClick={() => handleLinkClick(link.path)}
                onKeyDown={(e) => handleKeyDown(e, link.path)}
                aria-label={`Navigate to ${link.title}`}
                tabIndex={0}
              >
                <span className="menu-index">{String(index + 1).padStart(2, '0')}</span>
                <span className="menu-icon">{link.icon}</span>
                <span className="menu-text">
                  <span className="menu-label">{link.title}</span>
                  <span className="menu-desc">{link.desc}</span>
                </span>
                <span className="menu-arrow">▸</span>
              </button>
            ))}
          </div>

        </nav>

        {/* World Info Panel */}
        <div className="world-info-bar">
          <div className="world-info-header">
            <span className="world-info-title">WORLD INFO</span>
          </div>
          <div className="world-info-content">
            <div className="world-info-item">
              <span className="world-info-label">DATE</span>
              <span className="world-info-value">{formatDate(currentTime)}</span>
            </div>
            <div className="world-info-divider">│</div>
            <div className="world-info-item">
              <span className="world-info-label">TIME</span>
              <span className="world-info-value">{formatTime(currentTime)}</span>
            </div>
            <div className="world-info-divider">│</div>
            <div className="world-info-item">
              <span className="world-info-label">LAST SAVED</span>
              <span className="world-info-value">FEB 2026</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePage;
